<template>
  <b-container>
    <b-row>
      <b-col style="height: 2em">
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert show variant="info" dismissible class="font-weight-bold">
          On this page, you could search all rbps in a tumor site with the filter you set.
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col>

        <b-form @submit="onSubmit" @reset="onReset">

          <b-form-group id="TumorSiteGroup"
                        label="Tumor Site:"
                        label-for="TumorSite">
            <b-form-select id="TumorSite"
                           :options="tumorSite"
                           required
                           v-model="subData.tumorsite">
            </b-form-select>
          </b-form-group>

          <b-tabs>
            <b-tab
              v-for="(item,name) in form.detile"
              :key="name"
              :title="item.name"
              @click="sel(name)"
            >
              <div>
                <span>Set your filter:</span>
                <b-input-group class="pt-3" v-for="(filter,obj) in item.filters" :key="obj" v-b-tooltip.hover
                               :title="filter.desc">
                  <b-input-group-prepend is-text>
                    <input type="checkbox" v-model="filter.isUsed">
                  </b-input-group-prepend>
                  <b-input-group-prepend is-text>
                    {{ filter.label }}
                  </b-input-group-prepend>
                  <b-form-input :value="filter.value" type="number"></b-form-input>
                </b-input-group>

              </div>
            </b-tab>
          </b-tabs>

          <div class="mt-2">
            <b-button type="submit" variant="primary">Submit</b-button>
            <b-button type="reset" variant="danger">Reset</b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <FilterResult :result="res" v-if="res !== null" @clickTable="clickTable"></FilterResult>
  </b-container>
</template>

<script>
import FilterResult from './FilterResult'
const mytype = {
  degs_f: 'de',
  cnvs_f: 'gis',
  sur_f: 'sur'
}
// const unused = {
//   cnvs_f: {
//     name: 'Copy Number Variates',
//     id: 'cnv_radio',
//     filters: {
//       segment_mean: {label: 'segment_mean', value: 0.2, isUsed: true, desc: 'the threshold value of p-value', s: true}
//     },
//     popoverShow: false
//   }}
export default {
  name: 'myFilter',
  components: {
    FilterResult
  },
  data: () => ({
    tumorSite: [
      {text: 'Select One', value: null}
    ],
    form: {
      detile: {
        degs_f: {
          name: 'Differential Expression',
          id: 'de_radio',
          filters: {
            pvalue: {label: 'p-value', value: 0.05, isUsed: true, desc: 'the threshold value of p-value'},
            padj: {label: 'p-adj', value: 0.05, isUsed: true, desc: '12313123123123123'},
            log2FoldChange: {
              name: 'Survival Analysis',
              label: 'log2FC',
              value: 1,
              isUsed: true,
              desc: '12313123123123123',
              s: true
            }
          },
          popoverShow: false
        },
        sur_f: {
          name: 'Survival Analysis',
          id: 'sur_radio',
          filters: {
            pvalue: {label: 'p-value', value: 0.05, isUsed: true, desc: 'the threshold value of p-value'}
          },
          popoverShow: false
        }
      },
      tumorsite: null,
      type: null
    },
    subData: {
      type: 'degs_f',
      tumorsite: null,
      filters: {},
      method: 'filter'
    },
    res: null
  }),
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let filter = this.form.detile[this.subData.type].filters
      for (let i in filter) {
        let item = filter[i]
        if (item.isUsed === true) {
          this.subData.filters[i] = {value: item.value, needABS: item.s}
        }
      }

      // console.log(JSON.stringify(this.subData))
      this.axios({
        method: 'post',
        url: '/search.php',
        data: this.subData
      }).then(res => {
        this.res = res.data
      })
    },

    onReset (evt) {
      evt.preventDefault()
      this.form.rbp = ''
      this.res = null
      this.form.tumorsite = null
    },
    sel (name) {
      this.subData.type = name
    },
    toSearch () {
      this.$router.push({name: 'Search', params: {id: '1'}})
    },
    clickTable (data) {
      this.$router.push({
        name: 'Search',
        params: {
          haspar: true,
          method: 'search',
          rbp: data.symbol,
          tumorsite: data.tumorsite,
          type: [mytype[this.subData.type]]
        }
      })
    }
  },
  mounted () {
    this.axios({
      method: 'post',
      url: '/search.php',
      data: {
        method: 'search',
        'type': [ 'tumorSite' ]
      }
    }).then((res) => {
      this.tumorSite = [ {text: 'Select One', value: null} ].concat(res.data[ 'tumorSite' ].map(b => b.tumorsite))
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Filter.vue